<template>
	<!-- <el-container class="container_cloumn"> -->
	<div class="el-container container_cloumn" v-loading="pageloading">
		<vxe-toolbar>
			<template v-slot:buttons>
				<div  class="flex flex_row flex-nowrap">
					<el-button @click="select" :loading="loading" :disabled="loading" type="primary">查询</el-button>
					<el-button  @click="filterForm={}">清除</el-button>
					<!-- <div class="panel_hidden"> -->
					<c-filter :dataSource="(filterList||[]).slice(0,4)" :form="filterForm" :wrap="false"></c-filter>
					<!-- </div> -->
				</div>
			</template>
		</vxe-toolbar>
		<vxe-toolbar size="mini">
			<template v-slot:buttons>
				<div class="flex flex_row flex-nowrap">
					<el-button v-if="userRights['10']" @click="create">生成标签/打印</el-button>
					<el-button v-if="userRights['20']" @click="createAlready">已生成标签打印处理</el-button>
					<span class="_button flex flex_row flex-nowrap flex-vc">
						标签模板
						<vxe-select v-model="module">
							<vxe-option v-for="(module,index) in moduleList" :key="index" :value="module['代码']" :label="module['名称']"></vxe-option>
						</vxe-select>
					</span>
				</div>
			</template>
			<template v-slot:tools>
				<!-- <vxe-button type="text" icon="vxe-icon--question" class="tool-btn"></vxe-button> -->
				<vxe-button type="text" class="tool-btn _icon_button" title="筛选" @click="$refs.filtermodal.open()">
					<i class="iconfont vxe-button--icon vxe-icon--funnel iconSize " ></i>
				</vxe-button>
				<!-- <vxe-button title="筛选" type="text" icon="vxe-icon--funnel" class="tool-btn" @click="$refs.filtermodal.open()"></vxe-button> -->
				<vxe-button type="text" class="tool-btn _icon_button" title="标签设计" @click="createCodeInDo({value:'design_',type:'design'})">
					<i class="iconfont icon-icon-design- iconSize " ></i>
				</vxe-button>
				<vxe-button type="text" class="tool-btn _icon_button" title="导出数据" @click="$refs.ctable.exportDataEvent()">
					<i class="iconfont icon-export iconSize " ></i>
				</vxe-button>
				<!-- <vxe-button type="text" class="tool-btn _icon_button" title="页面设置" @click="toSetting({value:'design'})">
					<i class="iconfont icon-setting iconSize " ></i>
				</vxe-button> -->
			</template>
		</vxe-toolbar>
		<!-- <div class="table_height">123</div> @close="$refs.ctable.$refs.xTable.clearCheckboxRow();modaltable.table=[];modaltable.head=[];"-->
		<c-table ref="ctable" :table="table" class="table_height print_selecttable_div" v-loading="loading"></c-table>
		<vxe-modal ref="filtermodal" title="筛选条件" :mask="false" :show-zoom="true" :resize="true" :lock-view="false" width="700" height="500" remember :zIndex="2001">
			<template v-slot:header>
				<el-button  @click="select" :loading="loading" :disabled="loading">查询</el-button>
				<el-button  @click="filterForm={}">清除</el-button>
				<el-button  @click="$refs.filtermodal.close()">退出</el-button>
			</template>
			<template v-slot>
				<div style="width: 100%;">
					<c-filter :dataSource="filterList" :form="filterForm" :wrap="true"></c-filter>
				</div>
			</template>
		</vxe-modal>
		<vxe-modal ref="CreateModal" title="生成标签" :mask="false" :show-zoom="true" :resize="true" :lock-view="false" width="600" height="500" :loading="CreateModalloading" @zoom="zoom($event,1)"
		:before-hide-method="beforeHideMethod1"
		>
			<template v-slot>
				<el-tabs ref="eltabs" v-model="activeName" @tab-click="tabClick">
					<el-tab-pane label="标签打印信息" name="first"></el-tab-pane>
					<el-tab-pane label="生成标签" name="second" ></el-tab-pane>
				</el-tabs>
				<vxe-toolbar>
						<template v-slot:buttons>
							<div class="flex flex_row flex-vc flex-nowrap">
								<el-button v-if="userRights['11']" v-show="activeName=='first'" :disabled="createdTable.data.length>0||cploading" @click="createCodeInDo({value:'print_create',type:'print'})" :loading="cploading">生成并打印标签</el-button>
								<el-button v-if="userRights['12']" v-show="activeName=='first'" :disabled="createdTable.data.length>0||cloading"  @click="createCodeInDo({value:'create'})" :loading="cloading">生成标签</el-button>
								<el-button v-if="userRights['14']" v-show="activeName!='first'" :disabled="createdTable.data.length==0||createV" :loading="createV" @click="createCodeInDo({value:'print',type:'preview',name:'createV'})">预览标签</el-button>
								<el-button v-if="userRights['13']" v-show="activeName!='first'" :disabled="createdTable.data.length==0||createP" :loading="createP" @click="createCodeInDo({value:'print',type:'print',name:'createP'})">打印标签</el-button>
								<vxe-button type="text" class="tool-btn _icon_button" title="更新数据行" :disabled="activeName!='first'" v-if="activeName=='first'" @click="create">
									<i class="iconfont icon-zhongzhi iconSize " ></i>
								</vxe-button>
								<!-- <el-button :disabled="activeName!='first'" v-if="activeName=='first'" @click="create">刷新</el-button> -->
							</div>
							
							<!-- <el-button :disabled="activeName!='second'">打印</el-button> -->
							<!-- <el-dropdown @command="dropclick" class="_button">
								<span class="el-dropdown-link">
									<img src="../assets/more_point.png" style="width: 30px;height: 30px;"/>
								</span>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item  command="design" >
										标签设计
									</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown> -->
						</template>
						<template v-slot:tools>
							标签模板
							<span class="_button">
								<vxe-select v-model="module">
									<vxe-option v-for="(module,index) in moduleList" :key="index" :value="module['代码']" :label="module['名称']"></vxe-option>
								</vxe-select>
							</span>
						</template>
				</vxe-toolbar>
				<vxe-toolbar v-show="activeName=='first'">
						<template v-slot:buttons>
							<vxe-button type="text" class="tool-btn _icon_button" title="行复制" :disabled="activeName!='first'" v-if="activeName=='first'" @click="rowCopy">
								<i class="iconfont icon-Copy iconSize " ></i>
							</vxe-button>
							<vxe-button type="text" class="tool-btn _icon_button" title="行删除" :disabled="activeName!='first'" v-if="activeName=='first'" @click="rowCut">
								<i class="iconfont icon-editor-row-delete iconSize" ></i>
							</vxe-button>
							<vxe-button type="text" class="tool-btn _icon_button" title="批量填充" :disabled="activeName!='first'" v-if="activeName=='first'" @click="rowsWrite">
								<i class="iconfont icon-all_copy iconSize" ></i>
							</vxe-button>
						</template>
				</vxe-toolbar>
				<div class="modal_table_div">
					
					<c-table v-show="activeName!='first'" ref="createtableModaltable1" :table="createdTable" class="table_height" :coltype="''"
					:tabletype="activeName=='first'?'edit':'normal'"
					@cellEditActived="$refs.createtableModaltable.$el.setAttribute('currentColName',$event.column.property);$refs.createtableModaltable.$el.setAttribute('RowIndex',$event.rowIndex)"></c-table>
					<c-table v-show="activeName=='first'" ref="createtableModaltable" :table="createTable" class="table_height" :coltype="'seq'"
					:tabletype="activeName=='first'?'edit':'normal'"
					@cellEditActived="$refs.createtableModaltable.$el.setAttribute('currentColName',$event.column.property);$refs.createtableModaltable.$el.setAttribute('RowIndex',$event.rowIndex)"></c-table>
				</div>
			</template>
			
		</vxe-modal>
		<!-- @close="$refs.ctable.$refs.xTable.clearCheckboxRow();modaltable.table=[];modaltable.head=[];" -->
		<!-- 关闭时还需要清除选中的内容 -->
		<vxe-modal ref="tableModal" title="已生成标签打印处理" :mask="false" :show-zoom="true" :resize="true" :lock-view="false" width="600" height="500" :loading="modalloading" @zoom="zoom($event,2)"
		:before-hide-method="beforeHideMethod"
		>
			<template v-slot>
				<vxe-toolbar>
					<template v-slot:buttons>
						<div class="flex flex_row flex-nowrap">
							<el-button v-if="userRights['21']" @click="createCodeInDo({value:'print_already',type:'preview',name:'createModalV'})" :loading="createModalV" :disabled="createModalV">预览</el-button>
							<el-button v-if="userRights['21']" @click="createCodeInDo({value:'print_already',type:'print',name:'createModalP'})" :loading="createModalP" :disabled="createModalP">打印</el-button>
							<el-button v-if="userRights['22']" @click="createCodeInDo({value:'invalid_already'})" :loading="invalidLoading" :disabled="invalidLoading">标签作废</el-button>
							<!-- <el-dropdown @command="dropclick" class="_button">
								<span class="el-dropdown-link">
									<img src="../assets/more_point.png" style="width: 30px;height: 30px;"/>
								</span>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item  command="design" >
										标签设计
									</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown> -->
						</div>
					</template>
					<template v-slot:tools>
						<div id="print_A_Moudle">
							标签模板
							<span class="_button" >
								<vxe-select v-model="modalMoudle" :disabled="!createdChangeP">
									<vxe-option v-for="(module,index) in moduleList" :key="index" :value="module['代码']" :label="module['名称']"></vxe-option>
								</vxe-select>
							</span>
						</div>
					</template>
				</vxe-toolbar>
				<vxe-toolbar style="height: 16px;">
						<template v-slot:buttons>
							<!-- <vxe-button type="text" class="tool-btn _icon_button" title="标签设计" @click="createCodeInDo({value:'design_already',type:'design'})">
								<i class="iconfont icon-icon-design- iconSize " ></i>
							</vxe-button> -->
							<vxe-button type="text" class="tool-btn _icon_button" title="重新查询"  @click="createAlready">
								<i class="iconfont icon-zhongzhi iconSize " ></i>
							</vxe-button>
							<el-checkbox v-model="createdChangeP">切换模板</el-checkbox>
						</template>
				</vxe-toolbar>
				<div class="modal_table_div">
					<c-table ref="ctableModaltable" :table="modaltable" class="table_height" coltype="checkbox" @getRow="getCurrenMoudle"></c-table>
				</div>
			</template>
		</vxe-modal>
		<vxe-modal ref="tablePageset" title="设置" :mask="false" :show-zoom="true" :resize="true" :lock-view="false" width="600" height="500" :loading="modalloading" @zoom="zoom($event,2)"
		:before-hide-method="beforeHideMethod"
		>
			<template v-slot>
				<el-tabs ref="eltabs" v-model="activeName" @tab-click="tabClick">
					<el-tab-pane label="列显示设置" name="first"></el-tab-pane>
					<el-tab-pane label="过滤条件设置" name="second" ></el-tab-pane>
				</el-tabs>
				<vxe-toolbar>
					<template v-slot:buttons>
						<div class="flex flex_row flex-nowrap">
							<el-button @click="createCodeInDo({value:'print_already',type:'preview',name:'createModalV'})" :loading="createModalV" :disabled="createModalV">保存</el-button>
						</div>
					</template>
				</vxe-toolbar>
				<div class="modal_table_div">
					<!-- 序号/列名/列宽/显示/显示名称/是否固定列 -->
					<!-- 列名/数据类型/过滤条件 -->
					<!-- <c-table ref="ctableModaltable" :table="modaltable" class="table_height" coltype="checkbox" @getRow="getCurrenMoudle"></c-table> -->
				</div>
			</template>
		</vxe-modal>
		<printset ref="printset" type="1"></printset>
	</div>
	<!-- </el-container> -->
</template>

<script>
	import cfilter from './filter.vue'
	import printset from '../components/printset.vue'
	export default {
		name: 'print',
		props: ['routePath'],
		data() {
			return {
				table: { //arr.contact 合并元素
					pagesize: 15,
					currentPage: 1,
					head: [],
					data: [],
					_height:undefined
				},
				printdata: false,
				moduleList: [],
				module: '',
				filterList: [],
				filterForm: {},
				loading:false,
				pageloading:false,
				modaltable: { //arr.contact 合并元素
					pagesize: 15,
					currentPage: 1,
					head: [],
					data: []
				},
				modalloading:false,
				modalMoudle:'',//重新打印的标签
				createModalP:false,
				createModalV:false,
				CreateModalloading:false,
				cloading:false,
				cploading:false,
				createTable:{
					pagesize: 15,
					currentPage: 1,
					head: [],
					data: []
				},
				createP:false,
				createV:false,
				createdTable:{
					pagesize: 15,
					currentPage: 1,
					head: [],
					data: []
				},
				createdChangeP:false,
				invalidLoading:false,//作废loading
				activeName:'first',
			}
		},
		components: {
			"c-filter": cfilter,
			printset
		},
		computed: {
			//注意当切换成切其他的tab时，这个值也会改变	
			TabItem() {
				if (this.routePath) {
					return {};
				}
				if (this.$route.meta.menu) {
					return this.$route.meta.menu[this.$route.fullPath];
				}
				return {};
			},
			userRights(){
				let fnumber=this.TabItem['FNumber'];
				// console.log(this.$store.getters.UserRight[fnumber],fnumber,this.TabItem)
				return fnumber&&this.$store.getters.UserRight[fnumber]||{};//''=>false
			}
		},
		methods: {
			zoom(e,modal){//弹框里的表格高度不自适应 的解决
				let elearr=document.getElementsByClassName('modal_table_div');
				for(let elem in elearr){
					let height=elearr[elem].offsetHeight*0.85;
					if(height>0){
						// console.log(modal,elem,elearr[elem].offsetHeight,height,this.createTable._height,this.modaltable._height)
						if(isNaN(height)) return;
						if((this.createTable._height==height&&modal==1)||(this.modaltable._height==height&&modal==2)) return;
						if((!isNaN(this.createTable._height-height)&&Math.abs(this.createTable._height-height)<10&&modal==1)
							||(!isNaN(this.modaltable._height-height)&&Math.abs(this.modaltable._height-height)<10&&modal==2))  return;
						if(this.$refs.createtableModaltable&&modal==1){
							this.createTable._height=height;
							this.createdTable._height=height;
							this.$refs.createtableModaltable.$forceUpdate();
						}
						if(this.$refs.createtableModaltable1) this.$refs.createtableModaltable1.$forceUpdate()
						if(this.$refs.ctableModaltable&&modal==2){
							this.modaltable._height=height;
							this.$refs.ctableModaltable.$forceUpdate();
						}
					}
					// console.log(this.createTable._height,height);
				}
				
				// if(type=='max')
			},
			async createCodeInDo({value,type,name}){
				try{
					var selectData=[];
					var printset=this.$store.getters.UserInfo._printset;//localStorage.getItem('printset');
					if(value.includes('print')){
						//检查是否已经选择了打印的方式
						if(printset==null||String(printset)=='undefined'){
							this.$confirm('请先设置打印方式', '提示', {
								confirmButtonText: '确定',
								cancelButtonText: '取消',
								type: 'warning'
								}).then(() => {
									this.$refs.printset.open();
							})
							return;
						}
						if(printset!='M10'&&printset!='WebHtml'&&printset!='socket'){
							this.$confirm('请先设置打印方式', '提示', {
								confirmButtonText: '确定',
								cancelButtonText: '取消',
								type: 'warning'
								}).then(() => {
									this.$refs.printset.open();
							})
							return;
						}
					}
					if(!value.includes('design'))
						if(value.includes('already')){
							let selectRecords = this.$refs.ctableModaltable.$refs.xTable.getCheckboxRecords();
							let selectreverse=this.$refs.ctableModaltable.$refs.xTable.getCheckboxReserveRecords();
							if(selectRecords.length==0&&selectreverse.length==0){ this.$BH().message('未选择记录');return;}
							selectData=selectreverse.concat(selectRecords);
						}else{
							selectData=this.createTable.data;
							if(selectData.length==0){ this.$BH().message('未选择记录');return;}
						}
					//生成标签
					if(value.includes('create')){
						let selectToCreate=this.createTable;
						//校验
						let res=false;
						await this.$BH().commit('print.checkCreate',{createTable:selectToCreate,res:()=>{res=true;}});
						console.log('loading1---');
						if(!res) return;
						if(value=='print_create')
							this.cploading=true;
						else this.cloading=true;
						//创建
						if(this.module==''){
							this.$BH().message('模板为空');
							return;
						}
						await new Promise((resolve)=>{
							this.$BH().commit('print.createCode',{
									data:{
										dtview:selectToCreate.data,
										user:'NBBHTEC',
										funcnumber:this.TabItem['FFuncNumber'],
										templateNumber:this.module
									},
									success:(response)=>{
										let {columns,data}=response.data.value;
										this.createdTable.head=columns;
										this.createdTable.data=data;
										this.activeName='second';
										// console.log(this.createdTable);
										resolve(value.replace('create',''));
									},
									loadingcontrol:()=>{
										if(value=='print_create')
											this.cploading=false;
										else this.cloading=false;
									}
							});
							// return;
						})
						// .then((res)=>{
						// 	this.createCodeInDo({value:res})
						// }) 
						console.log('loading2---')
						// console.log('shuxnu2')
					}
					//打印标签
					if(value.includes('print')){
						if(value.includes('already')){
							// let selectData=selectreverse.concat(selectRecords);
							if(!this.createdChangeP){//不强制
								let diff=false;
								for(let i in selectData){
									if(selectData[0]['打印模板']!=selectData[i]['打印模板']){
										diff=true;
										break;
									}
								}
								if(diff){
									this.$BH().message('选中记录模板不一致');
									return;
								}else{
									this.module=selectData[0]['打印模板'];
									if(printset=='M10') return;
									// this.toPrint();
									this[name]=true;
									await this.$BH().commit('print.toPrint',{
										data:{
											templateNumber:this.module,
											moudleData:selectData,
											FuncNumer:this.TabItem['FFuncNumber'],
											strUser:this.$store.getters.UserInfo.username
										},
										type,
										loadingcontrol:()=>{
											this[name]=false;
										}
									})
								}
							}else{
								if(!this.modalMoudle||this.modalMoudle==''){
									this.$BH().message('请先选择模板');
									return;
								}
								// this.toPrint();
								if(printset=='M10') return;
								this[name]=true;
								await this.$BH().commit('print.toPrint',{
										data:{
											templateNumber:this.modalMoudle,
											moudleData:selectData,
											FuncNumer:this.TabItem['FFuncNumber'],
											strUser:this.$store.getters.UserInfo.username
										},
										loadingcontrol:()=>{
											this[name]=false;
										},
										type
									})
							}
						}else{//创建时的打印标签
							// this.toPrint();
							if(printset=='M10') return;
							if(!this.module||this.module==''){
								this.$BH().message('请先选择模板');
								return;
							}
							await this.$BH().commit('print.toPrint',{
										data:{
											templateNumber:this.module,
											moudleData:selectData,
											FuncNumer:this.TabItem['FFuncNumber'],
											strUser:this.$store.getters.UserInfo.username
										},
										loadingcontrol:()=>{
											this[name]=false;
										},
										type
									})
							return;
						}
					}
					//作废标签
					if(value.includes('invalid')){
						this.invalidLoading=true;
						await this.$BH().commit('print.invalidCode',{
							data:{
								rows:selectData,
								user:this.$store.getters.UserInfo.username
							},
							success:()=>{
								this.$BH().message('作废成功');
								for(let i in selectData){
									selectData[i]['标签状态']='作废';
									// let arr=this.modaltable.data.filter((item)=>{
									// 	return item['自增列']==selectData[i]['自增列'];
									// });
									// console.log(arr)
									// if(arr.length>0)
									// 	arr[0]['标签状态']='作废';
								}
							},
							loading:()=>{
								this.invalidLoading=false;
							}
						});
					}
					//模板设计
					if(value.includes('design')){
						if(!this.module||this.module==''){
							this.$BH().message('请先选择模板');
							return;
						}
						await this.$BH().commit('print.toPrint',{
									data:{
										templateNumber:this.module,
										moudleData:selectData,
										FuncNumer:this.TabItem['FFuncNumber'],
										strUser:this.$store.getters.UserInfo.username
									},
									loadingcontrol:()=>{
									},
									type
								})
						return;
					}
								
				}catch(e){
					//TODO handle the exception
					this.$BH().message(e);
				}
			},
			async beforeHideMethod () {
				if(this.invalidLoading){
					this.$BH().message('正在作废中，请稍后关闭窗口')
					return new Error()
				}
			},
			async beforeHideMethod1(){
				if(this.cploading||this.cloading){
					this.$BH().message('正在生成标签中，请稍后关闭窗口')
					return new Error()
				}
				this.createTable.data=[];
				this.createdTable.data=[];
				this.createdTable.head=[];
			},
			toSetting(){
				
			},
			toDesign({value}){
				
			},
			rowCopy(){
				let currenttrow=this.$refs.createtableModaltable.$refs.xTable.getCurrentRecord();
				if(currenttrow==null){
					this.$BH().message('未选中行');
					return;
				}
				currenttrow=JSON.parse(JSON.stringify(currenttrow));
				let {rowid}=this.table;
				if(!rowid) rowid='_id';
				// console.log(currenttrow)
				if(this.table.data&&this.table.data.length>0&&this.createTable.data&&this.createTable.data.length>0){
					currenttrow[rowid+'_']=Number(currenttrow[rowid]);
					currenttrow[rowid]=Number(this.table.data.length)+Number(this.createTable.data.length);
				}else
					currenttrow[rowid]=0;
				// console.log(currenttrow[rowid])
				this.createTable.data.push(JSON.parse(JSON.stringify(currenttrow)));
			},
			rowCut(){
				let currenttrow=this.$refs.createtableModaltable.$refs.xTable.getCurrentRecord();
				if(currenttrow==null){
					this.$BH().message('未选中行');
					return;
				}
				let idnex=this.createTable.data.indexOf(currenttrow);
				this.createTable.data.splice(idnex,1);
			},
			rowsWrite(){//批量赋值
				let currentcolname=this.$refs.createtableModaltable.$el.getAttribute('currentcolname');
				let index=this.$refs.createtableModaltable.$el.getAttribute('RowIndex');
				// console.log(index,window.M10.base.checkNumber(index)	)
				if(index!=''&&index!=null&&index!=undefined){
					index=Number(index);
					if(currentcolname!=undefined&&currentcolname!=null&&currentcolname!=''&&this.createTable.data&&this.createTable.data.length>0&&window.M10.base.checkNumber(index)){
						let _value=this.createTable.data[index][currentcolname];
						//被赋值这一行的呃计算
						this.$BH().calculatePrint(this.createTable.data[index],currentcolname,_value);
						for(let i=index+1;i<this.createTable.data.length;i++){
							this.createTable.data[i][currentcolname]=_value;
							this.$BH().calculatePrint(this.createTable.data[i],currentcolname,_value);
							// console.log(i,this.createTable.data[i])
						}
						console.log('fuzhi---')
						this.$refs.createtableModaltable.$forceUpdate();
						this.$refs.createtableModaltable.$el.setAttribute('currentcolname','');
						this.$refs.createtableModaltable.$el.setAttribute('currentcolname','');
					}
				}
				
			},
			tabClick(){
				console.log(this.createTable)
				console.log(this.createdTable)
				// this.$refs.createtableModaltable.$refs.xTable.refreshColumn();
			},
			getCurrenMoudle({row}){
				// console.log(row)
				// if(this.modalMoudle)
				// 	if(this.modalMoudle||this.modalMoudle==row['打印模板'])
				// 		this.modalMoudle=row['打印模板'];
				// 	else this.modalMoudle=undefined;
			},
			select() {
				if(this.loading) return;
				this.loading=true;
				this.$refs.ctable.$refs.xTable.clearCheckboxRow();
				this.$refs.ctable.$refs.xTable.clearCheckboxReserve();
				window.M10.base.http({
					url: 'Web/PrintDataSelect',
					data: {
						FuncNumber: this.TabItem['FFuncNumber'],
						PageNumber: this.TabItem['FNumber'],
						FFormName: this.TabItem['FFormName'],
						FUser: 'NBBHTEC',
						filterForm: this.filterForm,
						filterList: this.filterList
					},
					success: (response) => {
						console.log(response)
						let {
							data,
							funcinfo,
							pageSet
						} = response.data.value;
						this.table.data = data;
						if(data.length==0) this.$BH().message('无数据');
						this.table.currentPage = 1;
						for (let i in this.table.head) {
							let name = this.table.head[i]['name'];
							let pagefilter = pageSet.filter((item) => {
								return item['列名'] == name;
							});
							let datafilter = funcinfo['BR_FuncInfo_Class'].filter((item) => {
								return item['数据源列'] == name;
							})
							if (pagefilter.length > 0) {
								this.table.head[i]['title'] = pagefilter[0]['显示名称'];
								this.table.head[i]['width'] = pagefilter[0]['列宽'];
								this.table.head[i]['fix'] = pagefilter[0]['是否固定列'] ? 'right' : '';
							}
							if (datafilter.length > 0) {
								this.table.head[i]['must'] = datafilter[0]['是否必录'];
								this.table.head[i]['hide'] = datafilter[0]['是否隐藏'];
							}
						}
					},
					fail:(response)=>{
						console.log(response)
					},
					loadingcontrol:()=>{
						this.loading=false;
					}
				})
			},
			createAlready() {
				//clear data last
				this.modaltable.data=[];
				this.modaltable.head=[];
				this.modalMoudle='';
				this.createdChangeP=false;
				let selectRecords = this.$refs.ctable.$refs.xTable.getCheckboxRecords()
				console.log(selectRecords)
				if(selectRecords.length==0){ this.$BH().message('未选择记录');return;}
				// if(this.module==''){ alert('未选择模板');return;}
				this.$refs.tableModal.open();
				this.modalloading=true;
				window.M10.base.http({
					url: 'Web/getCreatedCode',
					data: {
						FuncNumber: this.TabItem['FFuncNumber'],
						PageNumber: this.TabItem['FNumber'],
						FFormName: this.TabItem['FFormName'],
						FUser: 'NBBHTEC',
						Rows:selectRecords
					},
					success: (response) => {
						console.log(response);
						let {data,columns}=response.data.value;
						this.modaltable.data=data;
						this.modaltable.head=columns;
						this.modaltable.rowid='自增列';
					},
					loadingcontrol:()=>{
						this.modalloading=false;
					}
				})
			},
			create(){
				this.activeName='first';
				let selectRecords = this.$refs.ctable.$refs.xTable.getCheckboxRecords();
				let selectreverse=this.$refs.ctable.$refs.xTable.getCheckboxReserveRecords();
				// console.log(selectRecords,selectreverse,selectreverse.concat(selectRecords))
				
				if(selectRecords.length==0&&selectreverse.length==0){ this.$BH().message('未选择记录');this.createTable.data=[];return;}
				if(this.module==''){ this.$BH().message('未选择模板');return;}
				this.$refs.CreateModal.open();
				let createData=selectreverse.concat(selectRecords);
				createData=JSON.parse(JSON.stringify(createData));
				let {rowid}=this.createTable;
				if(!rowid) rowid='_id';
				
				let temparr=[]
				for(let i in createData){//类似求合集只需要保留找的到的内容
					let index=this.createTable.data.filter(item=>item[rowid]==createData[i][rowid]||item[rowid+'_']==createData[i][rowid]);
					// console.log(index)
					if(index.length==0) temparr.push(createData[i]);//新添加的
					for(let j in index){//原来就在的
						temparr.push(index[j]);
					}
				}
				if(this.createTable.data.length==0) 
					this.createTable.data=JSON.parse(JSON.stringify(createData));
				else this.createTable.data=temparr;
				var head=JSON.parse(JSON.stringify(this.table.head)) ;
				// head=window.M10.changeArr({name:'包装数量',arr:head});
				
				window.M10.changeArr({name:'包装数量',arr:head}).then((res)=>{
					window.M10.addPrintColums({arr:res}).then((_res)=>{
						this.createTable.head=_res;
					})
					
				});
			},
			makeloading(e){
				let {to,text}=e;
				this.pageloading=to;
				if(text&&text.toLowerCase()!='success') this.$BH().message(text);
			},
			
		},
		activated(){
			// console.log('activated')
			// console.log(this.TabItem,this.$route.meta.menu[this.$route.fullPath])
			if(this.pageloading==false){
				this.table._height='85%';
			}
		},
		deactivated(){
			// console.log('deactivated')
			// if(this.pageloading==false){
				if(document.getElementsByClassName('print_selecttable_div')&&document.getElementsByClassName('print_selecttable_div')[0])
					this.table._height=document.getElementsByClassName('print_selecttable_div')[0].offsetHeight*0.85;
			// }
		},
		mounted() {
			console.log('mounted')
		},
		created() {//在网络不好的情况下，需要在可以查询之后需要重新载入页面配置的信息
			// this.$emit('initPage',{to:true});
			console.log('create')
			this.makeloading({to:true})
			window.M10.base.http({
				url: 'Web/initPrintPage',
				data: {
					FuncNumber: this.TabItem['FFuncNumber'],
					PageNumber: this.TabItem['FNumber'],
					FFormName: this.TabItem['FFormName'],
					FUser: this.$store.getters.UserInfo.username
				},
				success: (response) => {
					console.log(this.TabItem,this.$route.fullPath)
					let {
						template,
						filter,
						columns
					} = response.data.value;
					this.moduleList = template.template;
					let module = template.template1[0];
					this.module = module ? module['ftnumber'] : undefined;
					let filterarr;
					if (filter && filter.length > 0) filterarr = filter;
					else filterarr = columns;
					//列名 数据类型
					let tempFilter = []
					for (let i in filterarr) {
						let name = filter && filter.length > 0 ? '列名' : '数据源列';
						let currentobj = {};
						currentobj['Display'] = filterarr[i][name];
						currentobj['name'] = filterarr[i][name];
						if (filterarr[i]['数据类型'].includes('varchar') || filterarr[i]['数据类型'].includes('String'))
							currentobj['type'] = 1;
						else if (filterarr[i]['数据类型'].includes('datetime') || filterarr[i]['数据类型'].includes('DateTime'))
							currentobj['type'] = 3;
						else if (filterarr[i]['数据类型'].includes('bit') || filterarr[i]['数据类型'].includes('Bool'))
							currentobj['type'] = 4;
						if (currentobj['type'])
							tempFilter.push(currentobj);
					}
					this.table.head = columns;
					this.filterList = tempFilter;
					this.$forceUpdate()
				},
				loadingcontrol:(res)=>{
					this.makeloading({to:false,text:res})
				}
			})
		}
	}
</script>

<style scoped>
	
	.container_cloumn {
		flex-direction: column;
		height: 100%;
		width: 100%;
	}

	.table_height {
		height: 100px;
		height: calc(100% - 100px);
		/* overflow: auto; */
	}
	.vxe-toolbar.size--mini * {
		font-size: 12px;
	}
	.vxe-toolbar.size--mini .el-button{
		padding: 9px 17px;
	}
	.modal_table_div{
		height: calc(100% - 200px);
	}
	.modal_table_div .table_height{
		height: 100%;
	}
</style>
